module.exports={
	"ProviderIdentifier": "Pict-Router",

	"AutoInitialize": true,
	"AutoInitializeOrdinal": 0,

	"Routes":
	[
		{
			"path": "/Home",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Dashboard`)~}"
		},
		{
			"path": "/Operations",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-OperationList`)~}"
		},
		{
			"path": "/OperationEdit",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-OperationEdit`)~}"
		},
		{
			"path": "/Schedule",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Schedule`)~}"
		},
		{
			"path": "/Manifests/detail/:runHash",
			"template": "{~LV:Pict.PictApplication.showManifestDetail(Record.data.runHash)~}"
		},
		{
			"path": "/Manifests/:filter",
			"template": "{~LV:Pict.PictApplication.showManifestsFiltered(Record.data.filter)~}"
		},
		{
			"path": "/Manifests",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-ManifestList`)~}"
		},
		{
			"path": "/PendingInput",
			"template": "{~LV:Pict.PictApplication.showManifestsFiltered(`waiting`)~}"
		},
		{
			"path": "/Beacons",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-BeaconList`)~}"
		},
		{
			"path": "/Timeline",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Timeline`)~}"
		},
		{
			"path": "/Capabilities",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-CapabilityHeatMap`)~}"
		},
		{
			"path": "/Throughput",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Throughput`)~}"
		},
		{
			"path": "/Constellation",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Constellation`)~}"
		},
		{
			"path": "/Fleet",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Fleet`)~}"
		},
		{
			"path": "/Timing",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-TimingView`)~}"
		},
		{
			"path": "/FlowEditor/:hash",
			"template": "{~LV:Pict.PictApplication.editOperationFromRoute(Record.data.hash)~}"
		},
		{
			"path": "/FlowEditor",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-FlowEditor`)~}"
		},
		{
			"path": "/Docs",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Documentation`)~}"
		},
		{
			"path": "/Login",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-Login`)~}"
		},
		{
			"path": "/Users",
			"template": "{~LV:Pict.PictApplication.showView(`Ultravisor-UserManagement`)~}"
		}
	]
}
